import { getForms } from "@starter/Framework/Store/Starter/Components/Form/FormSelectors";
import { BaseFormHandlerParameter, FormModel } from "@starter/Framework/Store/Starter/Components/Form/FormTypes";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

export interface EmptyFormHandlerParameter extends BaseFormHandlerParameter {}

export interface EmptyFormHandlerProps {
    forms: FormModel[];
}

type HandlerType = Handler<EmptyFormHandlerParameter, EmptyFormHandlerProps>;

export const EmptyFormInputs: HandlerType = props => {
    const stateForms = getForms(props.getState());
    const newFormsList = stateForms.map(x => {
        if (x.id === props.parameter.formId) {
            return {
                ...x,
                inputs: [],
            };
        }

        return x;
    });

    props.forms = newFormsList;
};

export const DispatchEmptyForm: HandlerType = props => {
    props.dispatch({
        type: "Starter/Components/Form/EmptyForm",
        forms: props.forms,
    });
};

export const chain = [EmptyFormInputs, DispatchEmptyForm];

const emptyForm = createHandlerChainRunner(chain, "EmptyForm");

export default emptyForm;
